import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { isAuthenticated } from './services/auth';

import SignIn from './pages/SignIn'
import NotFoundPage from './pages/NotFoundPage';
import LastEventsPage from './pages/LastEventsPage'
import Addinfo from './pages/Addinfo'
import Ranking from './pages/Ranking'
import Compare from './pages/CompareSellers'
import HistData from './pages/HistData'
import StoreInfo from './pages/StoreInfo'

import { useAppDispatch, useAppSelector } from './hooks';
import { setStores } from './slices/sessionSlice';

import signout from "./services/signout"

import api from "./services/api";
const jwt = require('jsonwebtoken');
var dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
var isSameOrAfter = require('dayjs/plugin/isSameOrAfter');
dayjs.extend(utc);
dayjs.extend(isSameOrAfter);
var Cookies = require("js-cookie");



const RoutesApp = () => {
    const dispatch = useAppDispatch();
    const stores = useAppSelector(state => state.session.stores);

    useEffect(() => {
        // console.log("Process env: ", process.env.REACT_APP_API_ENDPOINT_SOCKET);
        if (window.location.pathname === "/") {
            return
        }

        if (!Cookies.get("token")) {
            // Do nothing because the token is not available, 
            // NEVER redirect to '/' because the reset password and other pages
            // without token auth will be inaccessible
            return
        }

        // 1) Set username if it doesnt exists
        if (!sessionStorage.getItem("username")) {
            const AUTH_TOKEN = Cookies.get("token")
            let decoded = jwt.decode(AUTH_TOKEN);
            sessionStorage.setItem("username", decoded.username)
        }


        // 2) Get stores and save it locally if it didnt exists in session storage
        if (!sessionStorage.getItem('stores') || !stores.length) {
            api.get('getStoresByUser').then((res) => {
                const httpStores = res.data.map((object) => ({
                    "id": object.id,
                    "alias_id": object.alias_id,
                    "store_name": object.name,
                    "store_address": object.address,
                    "store_lat": object.latitude,
                    "store_long": object.longitude,
                    "store_services": object.services,
                    "store_services_addons": object.services_addons
                }));
                sessionStorage.setItem('stores', JSON.stringify(httpStores));
                dispatch(setStores(httpStores));
            }).catch((err) => {
                console.log(err);
            })
        }

        // Check if token will expire in the next 1 hour and refresh
        const AUTH_TOKEN = Cookies.get("token")
        let decoded = jwt.decode(AUTH_TOKEN);
        let dateExpiration = new Date(0)
        dateExpiration.setUTCSeconds(decoded.exp)
        console.log(dateExpiration)
        if (dayjs().add(1, 'h').isSameOrAfter(dateExpiration)) {
            signout()
        }
        // eslint-disable-next-line
    }, []);



    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<SignIn />} />
                {
                    isAuthenticated() ?
                        <>
                            <Route path="/vezo/lastevents" element={<LastEventsPage />} />
                            <Route path="/vezo/addinfo" element={<Addinfo />} />
                            <Route path="/vezo/ranking" element={<Ranking />} />
                            <Route path="/vezo/compare" element={<Compare />} />
                            <Route path="/vezo/histdata" element={<HistData />} />
                            <Route path="/vezo/storeinfo" element={<StoreInfo />} />
                        </>
                        :
                        <Route path="*" element={<NotFoundPage />} />
                }
            </Routes>
        </BrowserRouter>
    );
}

export default RoutesApp;